var app_campaigns_table_dash = $('#app-campaigns-dash-table');

if (app_campaigns_table_dash.length) {
    function initializeCampaignsDashTable(range = "") {
        var advertiser = app_campaigns_table_dash.attr('data-advertiser');

        app_campaigns_table_dash.DataTable({
            "processing": true,
            "serverSide": true,
            "searching": false,
            "info": false,
            "bFilter": false,
            "bInfo": false,
            "lengthChange": false,
            "scrollY": "245px",
            "scrollCollapse": true,
            ajax: {
                url: '/campaigns/dashboard?range=' + range,
                dataSrc: 'data',
            },
            order: [ 5, "desc" ],
            columns: [
                {data: 'name'},
                {data: 'advertiser'},
                {data: 'date_range'},
                {data: 'brand'},
                {data: 'product'},
                {data: 'created_at'},
            ],
            destroy: true,
            "columnDefs": [
                /*{
                    "targets": 4,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                    }
                },*/
                {
                    "targets": 0,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log('data_data_ ', rowData)
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },{
                    "targets": 1,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                    }
                },{
                    "targets": 2,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var start = moment(rowData.start, "YYYY-MM-DD HH:mm:ss");
                        var end = moment(rowData.end, "YYYY-MM-DD HH:mm:ss");
                        $(td).html('<i class="fa fa-clock-o"></i> ' + start.format("MMM. D, YYYY") + ' to ' + end.format("MMM. D, YYYY"));
                    }
                },
                {
                    "targets": 5,
                    "orderable": true,
                    "className": "text-center",
                    "createdCell": function (td, cellData, rowData, row, col) {
                        date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        $(td).html('<i class="fa fa-clock-o"></i> ' + date.format("MMM. D, YYYY"));
                    }
                },
            ]
        });
    }

    function deleteAdvertiserCampaign(urlVar) {
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Campaign deleted.');
                            initializeCampaignsTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });

    }
    initializeCampaignsDashTable(moment().startOf('year').format("YYYY-MM-DD") + "_" + moment().endOf('year').format("YYYY-MM-DD"));
}
